import Layout from '../../../components/Layout';
import { LevelTable } from './Table';

export default function Level() {
  return (
    <Layout>
      <LevelTable />
    </Layout>
  );
}
